import { render, staticRenderFns } from "./ChatIndex.vue?vue&type=template&id=890b2252&scoped=true"
import script from "./ChatIndex.vue?vue&type=script&lang=js"
export * from "./ChatIndex.vue?vue&type=script&lang=js"
import style0 from "./ChatIndex.vue?vue&type=style&index=0&id=890b2252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890b2252",
  null
  
)

export default component.exports